import { render } from "./customerGroupList.vue?vue&type=template&id=1a07e479&scoped=true"
import script from "./customerGroupList.vue?vue&type=script&lang=js"
export * from "./customerGroupList.vue?vue&type=script&lang=js"

import "./customerGroupList.vue?vue&type=style&index=0&id=1a07e479&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a07e479"]])

export default __exports__